/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Ctaband_TitleInputs */

const en_vc_ctaband_title = /** @type {(inputs: Vc_Ctaband_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start drawing in VectorCraft`)
};

const zh_vc_ctaband_title = /** @type {(inputs: Vc_Ctaband_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始用 VectorCraft 画图`)
};

/**
* | output |
* | --- |
* | "Start drawing in VectorCraft" |
*
* @param {Vc_Ctaband_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_ctaband_title = /** @type {((inputs?: Vc_Ctaband_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Ctaband_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_ctaband_title(inputs)
	return zh_vc_ctaband_title(inputs)
});
export { vc_ctaband_title as "vc.ctaband.title" }